import { useEffect } from 'react';
import Button from './ui/Button/Button';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchUserInfo } from '../utils/api';

interface Props {
  signOut: () => void;
  user: CognitoUserInterface;
}

const Header = ({ signOut, user }: Props): JSX.Element => {

  const { userInfo, loading, message, error } = useAppSelector((state) => state.userInfo);
  
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchUserInfo(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isAdmin = userInfo?.isAdmin;
  const permissions = userInfo?.permissions;

  if (error) {
    return (
      <div className="error">
        <span>{message}</span>
      </div>
    );
  }

  if (isAdmin) {
    return (
      <header className="App-header">
        <div className="navItems">
          <span>Columbia</span>
          <ul>
            <li>
              <NavLink to="/" activeClassName="selected" exact>
                Documents
              </NavLink>
            </li>
            {process?.env?.REACT_APP_TABS?.includes('DASHBOARD') && <li>
              <NavLink to="/dashboard" activeClassName="selected" exact>
                Dashboard
              </NavLink>
            </li>}
            <li>
              <NavLink to="/acronym" activeClassName="selected" exact>
                Acronyms
              </NavLink>
            </li>
            <li>
              <NavLink to="/replacements" activeClassName="selected" exact>
                Replacements
              </NavLink>
            </li>
            {process?.env?.REACT_APP_TABS?.includes('JOBS') &&
            <li>
              <NavLink to="/jobs" activeClassName="selected" exact>
                Jobs
              </NavLink>
            </li>}
            {process?.env?.REACT_APP_TABS?.includes('PODCASTS') &&
            <li>
              <NavLink to="/podcasts" activeClassName="selected" exact>
                Podcasts
              </NavLink>
            </li>}
            <li>
              <NavLink to="/groups" activeClassName="selected" exact>
                Groups
              </NavLink>
            </li>
            <li>
              <NavLink to="/users" activeClassName="selected" exact>
                Users
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" activeClassName="selected" exact>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" activeClassName="selected" exact>
                Contact
              </NavLink>
            </li>
          </ul>
        </div>

        <Button className="signOut" type="transparent" onClick={signOut}>
          <span style={{ marginRight: '10px' }}>{user.username}</span>
          <span style={{ marginRight: '10px' }}>Sign out</span><br />
          <FontAwesomeIcon icon={faSignOutAlt} size="2x" />
        </Button>
      </header>
    );
  }

  return (
    <header className="App-header">
      <div className="navItems">
        <span>Columbia</span>
        <ul>
          {permissions?.find(element => element.includes("documents.")) && (
            <li>
              <NavLink to="/" activeClassName="selected" exact>
                Documents
              </NavLink>
            </li>
          )}
          {process?.env?.REACT_APP_TABS?.includes('DASHBOARD') && permissions?.find(element => element.includes("dashboard.")) && (
            <li>
              <NavLink to="/dashboard" activeClassName="selected" exact>
                Dashboard
              </NavLink>
            </li>
          )}
          {permissions?.find(element => element.includes("jargon.")) && (
            <li>
              <NavLink to="/acronym" activeClassName="selected" exact>
                Acronyms
              </NavLink>
            </li>
          )}
          {permissions?.find(element => element.includes("replacements.")) && (
            <li>
              <NavLink to="/replacements" activeClassName="selected" exact>
                Replacements
              </NavLink>
            </li>
          )}
          {permissions?.find(element => element.includes("jobs.")) && (
            <li>
              <NavLink to="/jobs" activeClassName="selected" exact>
                Jobs
              </NavLink>
            </li>
          )}
          {permissions?.find(element => element.includes("podcasts.")) && (
            <li>
              <NavLink to="/podcasts" activeClassName="selected" exact>
                Podcasts
              </NavLink>
            </li>
          )}
          {permissions?.find(element => element.includes("groups.")) && (
            <li>
              <NavLink to="/groups" activeClassName="selected" exact>
                Groups
              </NavLink>
            </li>
          )}
          {permissions?.find(element => element.includes("users.")) && (
            <li>
              <NavLink to="/users" activeClassName="selected" exact>
                Users
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to="/about" activeClassName="selected" exact>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" activeClassName="selected" exact>
              Contact
            </NavLink>
          </li>
        </ul>
      </div>

      <Button className="signOut" type="transparent" onClick={signOut}>
        <span style={{ marginRight: '10px' }}>{user.username}</span>
        <span style={{ marginRight: '10px' }}>Sign out</span>
        <FontAwesomeIcon icon={faSignOutAlt} size="2x" />
      </Button>
    </header>
  );
};

export default Header;
